export * from './gasNetworks.service';
import { GasNetworksService } from './gasNetworks.service';

export * from './gasStations.service';
import { GasStationsService } from './gasStations.service';

export * from './user.service';
import { UserService } from './user.service';

export * from './trailer.service';
import { TrailerService } from './trailer.service';

export * from './order.service';
import { OrderService } from './order.service';

export * from './settings.service';
import { SettingsService } from './settings.service';

export * from './deferredUpdate.service';
import { DeferredUpdateService } from './deferredUpdate.service';

export const APIS = [GasNetworksService, GasStationsService, UserService, TrailerService, OrderService, SettingsService, DeferredUpdateService];
